export const getSelectionString = () => { var _a; return ((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString()) || ""; };
//# sourceMappingURL=getSelectionString.js.map